import { DatTextCodeDto } from '@resources/resources';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'body-horizontal-table',
  templateUrl: './body-horizontal-table.component.html'
})
export class BodyHorizontalTableComponent {

  @Input() textCode : DatTextCodeDto

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/body/horizontal-table/body-horizontal-table.component.ts